import { Box, Typography, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { companyApi, useFetchCompanyQuery } from '../../services/companyApi';
import { FormattedMessage } from 'react-intl';
import { resetSelectedCompany } from './companySearch/slice';
import type { AppDispatch } from '../../store/store';
import { businessPlanApi } from '../../services/businessPlan';
import { financialPlanApi } from '../../services/financialPlanApi';
import { projectApi } from '../../services/projectApi';
import { scenarioApi } from '../../services/scenarioApi';

export default function CompanyData(): JSX.Element {
	const dispatch = useDispatch<AppDispatch>();
	const companySearch = useSelector((state: any) => state.companySearch);

	const { data: company } = useFetchCompanyQuery(
		{ companyId: companySearch?.selected?.companyId },
		{
			skip: !companySearch?.selected?.companyId,
		},
	);

	const handleUnselectCompany = async () => {
		const companyId = companySearch?.selected?.companyId;

		dispatch(resetSelectedCompany());

		dispatch(companyApi.util.resetApiState());
		dispatch(businessPlanApi.util.resetApiState());
		dispatch(financialPlanApi.util.resetApiState());
		dispatch(projectApi.util.resetApiState());
		dispatch(scenarioApi.util.resetApiState());

		if (companyId) {
			dispatch(
				companyApi.util.invalidateTags([
					{ type: 'company', id: companyId },
					{ type: 'companyNotes', id: companyId },
				]),
			);
			dispatch(companyApi.util.updateQueryData('fetchCompany', { companyId }, () => undefined));
		}
	};

	return (
		<Box sx={{ backgroundColor: 'background.paper' }}>
			{companySearch?.selected?.companyId && company?.company && (
				<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
					<Typography>
						<FormattedMessage id='company.name' />
						{company.company.name} - {company.company.businessId}
					</Typography>
					<Button size='small' onClick={handleUnselectCompany} startIcon={<CloseIcon />} sx={{ ml: 'auto' }}>
						<FormattedMessage id='company.unselect' />
					</Button>
				</Box>
			)}
		</Box>
	);
}
